import { Box, Card, Typography } from "@mui/material";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const dealsList = [
  {
    src: "/Image/DashImage/Deals/dashboard_offer_image.png",
    href: "https://www.perplexity.ai/",
    // offer: "Get Upto 30% off",
    // desc: "Only at Lifestyle Shop, Rohini Branch",
  },
  {
    src: "/Image/DashImage/Deals/offer_dashboard_2.png",
    href: "https://openai.com/index/chatgpt/",
    // offer: "Get Upto 30% off",
    // desc: "Only at Lifestyle Shop, Rohini Branch",
  },
  {

    src: "/Image/DashImage/Deals/offer_dashboard_3.png",
    href: "https://one.google.com/ai-student",
    // offer: "Get Upto 30% off",
    // desc: "Only at Lifestyle Shop, Rohini Branch",
  },
  

];

const DealsCarousel = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const handleCardClick = (href) => {
    if (href) {
      window.open(href, '_blank');
    }
  };

  return (
    <Carousel
      responsive={responsive}
      swipeable={true}
      draggable={true}
      //   showDots={true}
      autoPlay={true}
      autoPlaySpeed={3000}
      arrows={false}
      infinite={true}
    >
      {dealsList.map((deal, idx) => (
        <Box
          key={idx}
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Card
            onClick={() => handleCardClick(deal.href)}
            sx={{
              width: "90%",
              aspectRatio: "3 / 4",  
              borderRadius: "20px",
              objectFit: "cover",
              position: "relative",
              background: `url('${deal.src}')`, // Removed black overlay gradient
              backgroundSize: "cover",
              backgroundPosition: "center top", // Adjusted to show more from the top
              boxShadow: "0px 0px 10px 1px #888888",
              mt: 2,
              mb: 2,
              cursor: deal.href ? "pointer" : "default", // Show pointer cursor only if href exists
              transition: "transform 0.2s ease-in-out",
              "&:hover": {
                transform: deal.href ? "scale(1.02)" : "none", // Add hover effect only if clickable
              },
            }}
          ></Card>
          <Box
            sx={{
              position: "absolute",
              bottom: 10,
              left: 30,
              width: "90%",
              display: "flex",
              flexDirection: "column",
              alignItems: "left",
              mb: 2,
            }}
          >
            {/* <img
              src="/Image/DashImage/Deals/deals_1_icon.svg"
              alt="deals"
              style={{ width: "25px" }}
            /> */}
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: 600,
                color: "#fff",
                textAlign: "left",
                textShadow: "2px 2px 4px rgba(0,0,0,0.7)", // Added text shadow for better visibility
              }}
            >
              {deal.offer}
            </Typography>
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: 400,
                color: "#fff",
                textAlign: "left",
                textShadow: "1px 1px 2px rgba(0,0,0,0.7)", // Added text shadow for better visibility
              }}
            >
              {deal.desc}
            </Typography>
          </Box>
        </Box>
      ))}
    </Carousel>
  );
};

export default DealsCarousel;